import { API_URLS } from '@helpers/api';
import brand from '@helpers/brand';
import { formatCurrency, formatCurrencyWhole } from '@helpers/currency';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import LoadingIndicator from '@stories/Components/LoadingIndicator/LoadingIndicator';
import { rgba } from 'polished';
import * as React from 'react';
import { useDebounce, useFirstMountState } from 'react-use';
import RangeSlider from '../RangeSlider/RangeSlider';
import S from './Calculator.styles';
const Calculator = (props) => {
    const isFirstMount = useFirstMountState();
    const [data, setData] = React.useState(props.initialData);
    const [value, setValue] = React.useState(props.initialValue);
    const [status, setStatus] = React.useState('initial');
    useDebounce(() => {
        if (isFirstMount) {
            return;
        }
        calculate();
    }, 300, [value]);
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, "Calculate your monthly payments"),
        React.createElement(S.Inner, null,
            React.createElement("div", null,
                React.createElement(S.Content, null, "Use our finance calculator to work out how much monthly payments to suit your budget."),
                React.createElement(S.Label, { htmlFor: "value" }, "Cost of your bedroom"),
                React.createElement(S.Value, null, formatCurrencyWhole(value)),
                React.createElement(RangeSlider, { id: "value", max: props.max, min: props.min, name: "value", step: props.step, value: value, onChange: (value) => {
                        setValue(value);
                    } }),
                React.createElement(S.ContentSmall, null, "The approval of your application depends on your financial circumstances and borrowing history. Hammonds Furniture Ltd acts as a credit broker and not the lender. Novuna Personal Finance acts as the lender.")),
            React.createElement("div", null,
                React.createElement(S.Content, null, "Estimated cost for this finance option"),
                React.createElement(S.DataTable, null,
                    React.createElement("dt", { "data-headline": true },
                        data.deferralPeriod ? data.loanPeriod - data.deferralPeriod : data.loanPeriod,
                        ' ',
                        "monthly repayments of:"),
                    React.createElement("dd", { "data-headline": true }, formatCurrency(data.repayment)),
                    React.createElement("dt", null, "Cash Price:"),
                    React.createElement("dd", null, formatCurrency(data.cashPrice)),
                    React.createElement("dt", null, "Deposit:"),
                    React.createElement("dd", null, formatCurrency(data.deposit)),
                    React.createElement("dt", null, "Amount borrowed:"),
                    React.createElement("dd", null, formatCurrency(data.borrowed)),
                    React.createElement("dt", null, "Loan period:"),
                    React.createElement("dd", null,
                        data.loanPeriod,
                        " months"),
                    !!data.deferralPeriod && (React.createElement(React.Fragment, null,
                        React.createElement("dt", null,
                            data.deferralPeriod,
                            " month deferral period"),
                        React.createElement("dd", null))),
                    React.createElement("dt", null, "Representative APR:"),
                    React.createElement("dd", null,
                        data.apr,
                        "%"),
                    React.createElement("dt", null, "Rate of Interest:"),
                    React.createElement("dd", null,
                        data.apr,
                        "% p.a"),
                    React.createElement("dt", null, "Total payable (inc. deposit):"),
                    React.createElement("dd", null, formatCurrency(data.totalPayable)),
                    !!data.earlySettlementFee && (React.createElement(React.Fragment, null,
                        React.createElement("dt", null, "Early settlement fee:"),
                        React.createElement("dd", null, formatCurrency(data.earlySettlementFee)))),
                    status === 'loading' && (React.createElement(LoadingIndicator, { bgColor: rgba(brand.green, 0.7), fgColor: brand.white, label: "Loading\u2026", layout: "absolute" }))))),
        props.cta && (React.createElement(S.CtaWrapper, null,
            React.createElement(LinkButton, { buttonType: "inverted", href: props.cta.url, target: props.cta.target }, props.cta.text)))));
    async function calculate() {
        setStatus('loading');
        const res = await fetch(API_URLS.postCalculate, {
            body: JSON.stringify({
                optionId: props.optionId,
                value,
                apr: props.initialData.apr,
                deposit: props.initialData.deposit,
                termMonths: props.initialData.loanPeriod,
                interestRate: props.initialData.interestRate,
            }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        setStatus('initial');
        if (!res.ok) {
            return;
        }
        const resData = (await res.json());
        setData(resData);
    }
};
export default Calculator;
